import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Sparkles, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const isCancel = window.location.pathname.includes("cancel");
  const [state, setState] = useState(isCancel ? "cancel" : "loading");
  const [lookupKey, setLookupKey] = useState("");
  const tries = useRef(0);

  useEffect(() => {
    if (isCancel || !sessionId) return;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setLookupKey(r.data.lookup_key || "");
          setState("paid");
          return;
        }
        if (r.data.payment_status === "failed" || r.data.payment_status === "expired") {
          setState("failed");
          return;
        }
      } catch { /* ignora e riprova */ }
      tries.current += 1;
      if (tries.current < 15) setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
  }, [sessionId, isCancel]);

  const successText = lookupKey === "arcana_sub_monthly"
    ? "Il tuo abbonamento è attivo. Benvenuta tra le stelle: 5 consultazioni al giorno e la tua domanda mensile per Virginia."
    : "Le 3 consultazioni sono state aggiunte al tuo account, con 2 approfondimenti inclusi per ciascuna.";

  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center" data-testid="payment-result-page">
      <div className="mystic-card p-10">
        {state === "loading" && (
          <>
            <Loader2 className="w-10 h-10 text-amber-400 mx-auto mb-5 animate-spin" />
            <h1 className="font-display text-2xl text-amber-100 mb-3">Conferma del pagamento…</h1>
            <p className="text-purple-200/70 text-sm" data-testid="payment-status-text">Sto verificando l'esito con Stripe. Un attimo.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <Sparkles className="w-10 h-10 text-amber-400 mx-auto mb-5" />
            <h1 className="font-display text-2xl text-amber-100 mb-3">Pagamento riuscito</h1>
            <p className="text-purple-200/70 text-sm mb-8" data-testid="payment-status-text">{successText}</p>
            <Link to="/lettura" data-testid="payment-success-cta" className="gold-btn inline-block px-8 py-3 text-sm">
              Inizia la tua lettura
            </Link>
          </>
        )}
        {(state === "cancel" || state === "failed" || state === "timeout") && (
          <>
            <XCircle className="w-10 h-10 text-purple-300/60 mx-auto mb-5" />
            <h1 className="font-display text-2xl text-amber-100 mb-3">
              {state === "cancel" ? "Pagamento annullato" : state === "failed" ? "Pagamento non riuscito" : "Verifica in ritardo"}
            </h1>
            <p className="text-purple-200/70 text-sm mb-8" data-testid="payment-status-text">
              {state === "cancel"
                ? "Nessun addebito è stato effettuato. Puoi riprovare quando vuoi."
                : state === "failed"
                  ? "Il pagamento non è andato a buon fine. Nessun addebito: riprova con un altro metodo."
                  : "La conferma sta tardando: se l'addebito è avvenuto, i tuoi crediti appariranno a breve nel tuo account."}
            </p>
            <Link to="/piani" data-testid="payment-back-btn" className="gold-btn inline-block px-8 py-3 text-sm">
              Torna ai piani
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
